<template>
  <div class="BomPartsMPNApiFilteredComponent  DataTables">
    <p>{{lang.infotext_1}}:</p>


    <div :id="id">
      <LoaderComponent  v-if="!isData"></LoaderComponent>
    </div>

    <br>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

import * as Tools from '../../Tools/Tools';
import dt from 'datatables.net-bs4';




require("datatables.net-select-bs4");
require("datatables.net-keytable");
require("datatables.net-buttons-bs4");
require("@/components/shared/DataTables/jszip.min.js");
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require("@/components/shared/DataTables/buttons.html5.min.js");
require("@/components/shared/DataTables/buttons.print.min.js");
require("@/components/shared/DataTables/buttons.colVis.min.js");

import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

import LoaderComponent from "@/components/shared/LoaderComponent"

import { mapGetters } from 'vuex'
export default {
  name: 'BomPartsMPNApiFilteredComponent',
  props:{
    lang: Object
  },
  components: {
    LoaderComponent,

  },
  data () {
      return {
        name: "BomPartsMPNApiFilteredComponent",
        id: "tableplace_"+this._uid,
        columns: [],
        colsAssign: [],

        dblclick: false,

        lengthMenu: 20,

        clickedColumnIndex: null,
        mouseXInTable: null,

      }
  },
  computed: {
    ...mapGetters({
      appConf: 'appConf',
      globalSettings: "globalSettings"

    }),
    isData(){

      return false
    },
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    revisionId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.id;


    },
    projectId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.projectId;

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }

    },
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    bomId() {
      return this.$route.query.bomId;
    }

  },
  created () {
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");

  },
  watch: {
    tabIndex: function () {

        if (this.mainTable != ""){
          this.mainTable.rows().deselect();
        }

    },
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.getProperties();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    bomId: function () {

      this.$parent.$parent.$parent.$parent.$parent.$parent.setIsCore(this.isCore);

      this.getProperties();

    }


  },

  mounted: function () {

    this.getProperties();


  },
  methods: {

    getProperties() {

      let reloadObj = {
        status: true,
        name: "Refresh"
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);

      let vue = this;



      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getBOMPartProperties")
      .then((result) => {

        //console.log(result)
        if (result.status == "OK") {
          if (result.data != null) {

            vue.buildColumns(result.data);
          }
        }



      })

    },


    buildColumns(properties){
      this.columns = [

        {
          name: "Id",
          alignInColumn: "left",
          type: "text",
          property: "col___bomPartId"
        },
        {
          name: this.lang.table_header_PartNumber,
          alignInColumn: "left",
          type: "text",
          property: "col___partNumber",
          propertyId: ""
        },

        {
          name: this.lang.table_header_Revision,
          alignInColumn: "left",
          type: "taxt",
          property: "col___revision",
          propertyId: ""
        },
        {
          name: this.lang.table_header_PartReference,
          alignInColumn: "left",
          type: "text",
          property: "col___partReference",
          propertyId: ""
        },
        {
          name: this.lang.table_header_Remarks,
          alignInColumn: "left",
          type: "text",
          property: "col___remarks",
          propertyId: ""
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "left",
          type: "text",
          property: "col___status",
          propertyId: ""
        },
        {
          name: this.lang.table_header_EOLalert,
          alignInColumn: "left",
          type: "text",
          property: "col___status",
          propertyId: ""
        },
        {
          name: this.lang.table_header_MPNs,
          alignInColumn: "left",
          type: "text",
          property: "col___status",
          propertyId: ""
        },



        ];

      this.colsAssign = [
        { "data": "col___bomPartId" },
        { "data": "col___partNumber" },
        { "data": "col___revision"},
        { "data": "col___partReference" },
        { "data": "col___remarks" },
        { "data": "col___status" },
        { "data": "col___eolAlert" },
        { "data": "col___mpns", orderable: false },
        //{ "data": "col___bomPartId" },

      ]



      properties.sort(function(a, b){return a.priority-b.priority});

      for (let i = 0, lei = properties.length; i < lei; i++){


            let obj = {
              name: properties[i].name,
              alignInColumn: "left",
              propertyId:properties[i].propertyId,
              type: "part",
              property: "col___"+properties[i].propertyId
            }
            this.columns.push(obj);


            let objAssign = {
              data: "col___"+properties[i].propertyId

            }

            this.colsAssign.push(objAssign)


      }




      this.buildTable();
    },

    buildTable(){


      //let lengthMenu = 20;

      //console.log('buildTable');

      // if (this.$store.getters.outerData != true){

      //   this.$store.dispatch("deleteAllSelectedRows");
      //   this.$store.dispatch("setOuterData", false);
      // }

      let tableplace = document.getElementById("tableplace_"+this._uid);
      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      let place = document.createElement("table");
      place.setAttribute("id", "place"+this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place)

      let tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      let thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);



      let columnDefs = [];


      let _vue = this;

      let len = this.columns.length;

      let y = 0;

      for (let i = 0; i < len; i++){

        let classname = '_dt-body-' + this.columns[i].alignInColumn;

        if (i == 7) {
          classname = '_dt-body-' + this.columns[i].alignInColumn + ' no-wrap';
        }

        let el = {
          targets: i,
          className: classname,
          render: function (data, type, row, meta) {

            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.value.display != undefined) {
              data.value.display = $.fn.dataTable.render.text().display(data.value.display);
            }

            if (meta.col == 0){

                return "<span class=\"nowrapForPartNumber\">" + data.partNumber + "</span>";


            }
            if (meta.col == 2) {
              return "<span class=\"part-reference\">" + data.revision + "</span>";
            }

            let toDisplay = "";
            if (data == undefined){

              data = {
                value: {
                  display: "<span style='color:red'>! " + meta.col + "-" + meta.row + "</span"
                }
              }
            }


            if (data.value != null){
              toDisplay = data.value.display;
            }


            if (meta.col == 5){
              if (data == undefined){
                  return ""
              }
              let str = "";
              // if (data == 0){
              //   str += "<b-badge class='badge badge-warning '>"+_vue.lang.tag_OutOfSync+"</b-badge>";
              // }else{
              //   str += "<b-badge class='badge badge-success '>"+_vue.lang.tag_Synchronized+"</b-badge>";
              // }

              if (data.status == "outOfSync") {
                str += "<b-badge class='badge badge-danger '>" + _vue.lang.tag_OutOfSync + "</b-badge>";
              } else if (data.status == "synchronized") {
                str += "<b-badge class='badge badge-success '>" + _vue.lang.tag_Synchronized + "</b-badge>";
              } else if (data.status == "oldRevision") {
                str += "<b-badge class='badge badge-warning '>" + _vue.lang.tag_OldRevision + "</b-badge>";
              }
              if (data.isManual == true) {
                str += " <b-badge class='badge badge-info '>" + _vue.lang.tag_IsManual + "</b-badge>";
              }
              if (data.isPresent == false) {
                str += " <b-badge class='badge badge-danger '>" + _vue.lang.tag_IsNotPresent + "</b-badge>";
              }
              toDisplay = str;
            }
            if (meta.col == 6) {

              if (data == undefined) {
                return ""
              }
              let str = "";

              if (data.endOfLifeAlert == true) {

                  str += "<b-badge class='badge badge-danger '>" + "EOL" + "</b-badge>";

              }
              if (data.endOfSaleAlert == true) {

                str += "<b-badge class='badge badge-danger '>" + "EOS" + "</b-badge>";

              }
              toDisplay = str;
            }
            if (meta.col == 7) {

              data.mpns.sort(function(a, b){return a.Priority-b.Priority});
              let str = '';
              if (_vue.globalSettings.SEDetails == false) {

                for (let i = 0, lei = data.mpns.length; i < lei; i++){

                  let tags = "";

                  let preferred = "";
                  if (data.mpns[i].isPreferred == true) {
                    preferred = _vue.lang.alert_Preferred;
                  }
                  tags += "<b-badge id=\"badge_" + data.mpns[i].DistributorPartId + "_preferred\" class=\"badge badge-success " + "bompart__" + data.mpns[i].DistributorPartId +"_preferred\">" + preferred + "</b-badge> ";

                  let nrnd = "";
                  if (data.mpns[i].isNRND == true) {
                    nrnd = _vue.lang.alert_NRND;
                  }
                  tags += "<b-badge id=\"badge_" + data.mpns[i].DistributorPartId + "_nrnd\" class=\"badge badge-purple " + "bompart__" + data.mpns[i].DistributorPartId + "_nrnd\">" + nrnd + "</b-badge> ";

                  let forbidden = "";
                  if (data.mpns[i].isForbidden == true) {
                    forbidden = _vue.lang.alert_Forbidden;
                  }
                  tags += "<b-badge id=\"badge_" + data.mpns[i].DistributorPartId + "_forbidden\" class=\"badge badge-danger " + "bompart__" + data.mpns[i].DistributorPartId +"_forbidden\">" + forbidden + "</b-badge> ";




                  if (data.mpns[i].isSelected == true){
                    let count = i + 1;
                    let mpnrow = "mpn-row";

                    if (i == lei - 1) {
                      mpnrow = "";
                    }
                    str += "<span class=\""+mpnrow+" mpnpart_" + data.mpns[i].DistributorPartId + "\">";
                    str += "<span class=\"inline-block\">";
                    str += count + ". " + data.mpns[i].ManufacturerPartNumber + " | " + data.mpns[i].ManufacturerName + " | " + data.mpns[i].Description;
                    if (tags != "") {
                      str += " | " + tags + "\r\n<br>";
                    } else {
                      str += "\r\n<br>";
                    }
                    str += "</span><br>";

                  }


                }

              } else {
                //str = '<table class="subtable">';
                  str = '';
                for (let i = 0, lei = data.mpns.length; i < lei; i++){

                  let tags = "";

                  let preferred = "";
                  if (data.mpns[i].isPreferred == true) {
                    preferred = _vue.lang.alert_Preferred;
                  }
                  tags += "<b-badge id=\"badge_" + data.mpns[i].DistributorPartId + "_preferred\" class=\"badge badge-success " + "bompart__" + data.mpns[i].DistributorPartId +"_preferred\">" + preferred + "</b-badge> ";

                  let nrnd = "";
                  if (data.mpns[i].isNRND == true) {
                    nrnd = _vue.lang.alert_NRND;
                  }
                  tags += "<b-badge id=\"badge_" + data.mpns[i].DistributorPartId + "_nrnd\" class=\"badge badge-purple " + "bompart__" + data.mpns[i].DistributorPartId + "_nrnd\">" + nrnd + "</b-badge> ";

                  let forbidden = "";
                  if (data.mpns[i].isForbidden == true) {
                    forbidden = _vue.lang.alert_Forbidden;
                  }
                  tags += "<b-badge id=\"badge_" + data.mpns[i].DistributorPartId + "_forbidden\" class=\"badge badge-danger " + "bompart__" + data.mpns[i].DistributorPartId +"_forbidden\">" + forbidden + "</b-badge> ";

                  let OverallRisk = "";
                  let valOverallRisk = "No data";
                  let statusOverallRisk = "primary";
                  if (data.mpns[i].OverallRisk != undefined) {
                    OverallRisk = data.mpns[i].OverallRisk.split("%");

                  }

                  let EstimatedYearsToEOL = "";
                  let valEstimatedYearsToEOL = "No data";
                  let statusEstimatedYearsToEOL = "primary";
                  if (data.mpns[i].EstimatedYearsToEOL != undefined) {
                    EstimatedYearsToEOL = data.mpns[i].EstimatedYearsToEOL;
                  }

                  if (OverallRisk != "") {
                    if (OverallRisk[0] <= _vue.globalSettings.SERiskRange1) {
                      valOverallRisk = "Low";
                      statusOverallRisk = "success";
                      if (OverallRisk == "") {
                        valOverallRisk = "No data";

                      }
                    }else if (OverallRisk[0] > _vue.globalSettings.SERiskRange2) {
                      valOverallRisk = "High";
                      statusOverallRisk = "danger";
                    } else if ((OverallRisk[0] > _vue.globalSettings.SERiskRange1) && (OverallRisk[0] <= _vue.globalSettings.SERiskRange2)) {
                      valOverallRisk = "Medium";
                      statusOverallRisk = "warning";
                    }
                  }

                  let value = parseFloat(EstimatedYearsToEOL);
                  let range1 = parseFloat(_vue.globalSettings.SEEOLRange1);
                  let range2 = parseFloat(_vue.globalSettings.SEEOLRange2);

                  if (EstimatedYearsToEOL != "") {
                    if (value <= range1) {
                      valEstimatedYearsToEOL = EstimatedYearsToEOL;
                      statusEstimatedYearsToEOL = "danger";

                    }else if (value > range2) {
                      valEstimatedYearsToEOL = EstimatedYearsToEOL;
                      statusEstimatedYearsToEOL = "success";
                    } else if ((value <= range2) && (value > range1)) {
                      valEstimatedYearsToEOL = EstimatedYearsToEOL;
                      statusEstimatedYearsToEOL = "warning";
                    }
                  }



                  if (data.mpns[i].isSelected == true) {

                    let mpnrow = "mpn-row";

                    if (i == lei - 1) {
                      mpnrow = "";
                    }

                    str += "<span class=\""+mpnrow+" mpnpart_" + data.mpns[i].DistributorPartId + "\">";
                    str += "<span class=\"inline-block\">";
                    let count = i + 1;
                    str += " " + count + ".";
                    str += "</span>";
                    str += "&nbsp;|&nbsp;<span class=\"se-risk inline-block\">";
                    if (OverallRisk[0] == 0 && data.mpns[i].LifecycleRisk == "Unknown") {

                      str += "SE Risk: <b-badge class='badge badge-orange '>Incomplete</b-badge>" + "<br>";
                    } else {

                      str += "SE Risk: <b-badge class='badge badge-"+statusOverallRisk+" '>"+valOverallRisk+" </b-badge>" + "<br>";

                    }
                    str += "</span>";
                    str += "&nbsp;|&nbsp;<span class=\"se-eol inline-block\">";
                    str += "SE EOL: <b-badge class='badge badge-"+statusEstimatedYearsToEOL+" '>"+valEstimatedYearsToEOL+" </b-badge>" + "<br>";
                    str += "</span>";
                    str += "&nbsp;|&nbsp;<span class=\"inline-block\" style=\"min-width:150px\">";
                    str += data.mpns[i].ManufacturerPartNumber + "<br>";
                    str += "</span>";
                    str += "&nbsp;|&nbsp;<span class=\"inline-block\" style=\"min-width:150px\">";
                    str += data.mpns[i].ManufacturerName + "<br>";
                    str += "</span>";
                    str += "&nbsp;|&nbsp;<span class=\"inline-block\">";
                    str += data.mpns[i].Description;
                    str += "</span>";
                    if (tags != "") {
                      str += "&nbsp;|&nbsp;<span class=\"inline-block\">";
                      str += tags + "<br>\n\r";
                      str += "</span>";
                    } else {
                      str += "<br>\n\r";
                    }
                    str += "<br></span>";
                  }


                }
                //str += "</table>";
              }




              toDisplay = str;
            }

            return  toDisplay;



          }
        }



      columnDefs.push(el);




        let th1 = document.createElement("th");

        tr1.appendChild(th1);

        let br = document.createElement("br");
        let tx = document.createTextNode(this.columns[i].name);
        if (this.columns[i].type == "part") {
          tx = document.createTextNode("["+this.columns[i].name+"]");
        }
        th1.appendChild(br);
        th1.appendChild(tx);
        //let input = document.createElement("input");
        //input.setAttribute("type", "text");
        //input.setAttribute("placeholder", "Search");
        //input.setAttribute("class", "form-control form-control-sm search-input-header");
        //th1.appendChild(input);


      }

        let vue = this;


      let option = {};


      option.keys = false;
      //json.data= datatable;
      option.myColumnFormats = this.columns;
      option.colReorder = false;
      option.lengthMenu = [[20, -1], [20, "All"]];
      option.order = [[ 1, "asc" ]];
      option.select = true;
      //option.searchDelay = 350;
      option.columns = this.colsAssign;
      option.columnDefs = columnDefs;

      option.dom = '<fBlr<t>ip>';

      option.processing= true;
      option.serverSide= true;

      option.initComplete = function (settings, json) {

        // vue.mainTable.columns().eq(0).each(function(colIdx) {
        //   $('input', vue.mainTable.column(colIdx).header()).on('keyup change', function () {
        //     vue.mainTable
        //       .column(colIdx)
        //       .search(this.value)
        //       .draw();
        //   });

        //   $('input', vue.mainTable.column(colIdx).header()).on('click', function(e) {
        //       e.stopPropagation();
        //   });
        //});


      }
      option.fnDrawCallback = function( oSettings ) {

        vue.buildContextMenu();
      }
      option.buttons = [

        {
          extend: 'copy',
          className: 'btn-' + vue.variant,
          exportOptions: {
              columns: ':visible'
          }
        },
        {
          extend: 'print',
          className: 'btn-' + vue.variant,
          messageTop: function () {
            let projectNumber = vue.$store.getters.projectDetails.projectNumber;
            let bomName = vue.$store.getters.bomDetails.name;
            return vue.lang.export_label_top1 + ": " + projectNumber + " | " + vue.lang.export_label_top2 + ": " + bomName;
          },
          exportOptions: {
            columns: ':visible'
          },
          autoPrint: true,
          style: 'fullWidth',

          customize: function ( win ) {
              $(win.document.body)
                  .css( 'font-size', '10pt' )


              $(win.document.body).find( 'table' )
                  .addClass( 'compact' )
                  .css( 'font-size', 'inherit' );
          }
        },
        {
          extend: 'csv',
          filename: vue.lang.export_label_top1 + "-" + vue.$store.getters.projectDetails.projectNumber + "_" + vue.lang.export_label_top2 + "-" + vue.$store.getters.bomDetails.name,
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
        },
        {
          extend: 'excel',
          filename: vue.lang.export_label_top1 + "-" + vue.$store.getters.projectDetails.projectNumber + "_" + vue.lang.export_label_top2 + "-" + vue.$store.getters.bomDetails.name,
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
            customize: function ( xlsx ){

            let sheet = xlsx.xl.worksheets['BOM.xml'];


        }},
        {
          extend: 'pdfHtml5',
          filename: vue.lang.export_label_top1 + "-" + vue.$store.getters.projectDetails.projectNumber + "_" + vue.lang.export_label_top2 + "-" + vue.$store.getters.bomDetails.name,
          messageTop: function () {
            let projectNumber = vue.$store.getters.projectDetails.projectNumber;
            let bomName = vue.$store.getters.bomDetails.name;
            return vue.lang.export_label_top1 + ": " + projectNumber + " | " + vue.lang.export_label_top2 + ": " + bomName;
          },
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
          orientation: 'landscape',
          pageSize: 'A4',
          download: 'open',

          styles: {
            fullWidth: {
                fontSize: 3,
                bold: true,
                alignment: 'right',
                margin: [0,1900,0,80]
            },
            subheader: {
                fontSize: 4
            },
            superMargin: {
                margin: [20, 0, 40, 0],
                fontSize: 5,
            }
          },
          customize: function ( doc ) {


            doc.pageMargins = [10,10,10,10];

            doc.styles.title.fontSize = 9;
            doc.defaultStyle.fontSize = 7;
            doc.styles.tableHeader.fontSize = 9;
            doc.content[0].text = doc.content[0].text.trim();

            let numberOfHeaders = columnDefs.length;

            if ((numberOfHeaders > 10)&&(numberOfHeaders < 15)){

              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if((numberOfHeaders >= 15)&&(numberOfHeaders < 18)){

              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if(numberOfHeaders >= 18){

              doc.defaultStyle.fontSize = 3;
              doc.styles.tableHeader.fontSize = 5;
            }

          },

        },
        {
        text: 'Json',
        exportOptions: {
          columns: ':visible'
        },
        className: 'btn-' + vue.variant,
            action: function ( e, dt, button, config ) {
                let data = dt.buttons.exportData();

                $.fn.dataTable.fileSave(
                    new Blob( [ JSON.stringify( data ) ] ),
                    vue.lang.export_label_top1 + "-" + vue.$store.getters.projectDetails.projectNumber + "_" + vue.lang.export_label_top2 + "-" + vue.$store.getters.bomDetails.name + ".json"
                );
            }
        },
        {
          text: 'Reload',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
          action: function (e, dt, button, config) {

            vue.mainTable.ajax.reload();
          }

        },

        {
          extend: 'colvis',
          className: 'btn-' + vue.variant,

        },


      ];

      option.ajax = {
        //url: /*this.server + */"/api/v3/partmanagement/parts/GetPhysicalHandmadeParts",
        url: /*this.server + */"/api/v3/projectmanagement/projects/GetBomWithMPNsApiFiltered",

        crossDomain: true,
        type: 'POST',
        dataType: 'json',
        cors: true,
        contentType: 'application/json',
        secure: false,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
        },
        error: function (xhr, ajaxOptions, thrownError) {

          // console.log(xhr.status)
          // console.log(thrownError)
          if (xhr.responseJSON == undefined) {
            let error = JSON.parse(xhr.responseText);


            let obj = {
              text: vue.lang.alert_error_GetParts + " " + error.message,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
            return;
          }
          if (xhr.responseJSON.message == "Authorization failure."){

            vue.$store.dispatch("logout");
          }

        },
        data: function ( json ) {



          for (let i = 0, lei = json.columns.length; i < lei; i++){
            json.columns[i].col = i;
          }


          json.bomId = vue.bomId;
          //console.log(json)


            return JSON.stringify(json);
          //}




        },
        dataFilter: function(data){
          //todo
          //vue.$store.dispatch("deleteAllSelectedRows");
          //console.log(data)

          y = 0;
          let json = JSON.parse(data);
            //console.log(json)
            if (json.data == null) {
              return
          }




          // json = {
          //   "status": "OK",
          //   "type": "BasicInfo",
          //   "data": {
          //     "draw": 1,
          //     "recordsTotal": 1,
          //     "recordsFiltered": 1,
          //     "data": [
          //       {
          //         "bomPartId": -2147480075,
          //         "PartNumber": "FC-CAP-0060",
          //         "Revision": "1",
          //         "PartReference": "C1",
          //         "Remarks": "bla bla",
          //         "revisionId": -2147442299,
          //         "partId": -2147450854,
          //         "isManual": false,
          //         "assembly": false,
          //         "status": "synchronized",
          //         "isPresent": true,
          //         "partProperties": [
          //           {
          //             propertyId: -12345,
          //             value: "10V",
          //             name: "Value",
          //             priority: 0
          //           },
          //           {
          //             propertyId: -12346,
          //             value: "Xilinx FPGA Virtex 5 BGA665",
          //             name: "Description",
          //             priority: 1
          //           },
          //           {
          //             propertyId: -12347,
          //             value: "cap_0204",
          //             name: "Footprint",
          //             priority: 1
          //           },

          //         ],
          //         "alternatives": [
          //           {
          //             "DistributorPartId": "84a6d539-5ebf-41ea-9d93-9251724658c1",
          //             "ManufacturerName": "KEMET",
          //             "ManufacturerPartNumber": "C0603C229B1GACAUTO",
          //             "Description": "Multilayer Ceramic Capacitors MLCC - SMD/SMT 100V 2.2pF 0603 C0G 0.1pF AEC-Q200",
          //             "Datasheet": "https://www.mouser.de/ProductDetail/KEMET/C0603C229B1GACAUTO?qs=dT9u2OTAaVVgifsxt%252BS4gg%3D%3D",
          //             "LoginAssign": "Authorised Support lvl I",
          //             "DateAssign": "2022-07-06T07:17:04.153",
          //             "LoginUnassign": null,
          //             "DateUnassign": null,
          //             "isSelected": true,
          //             "endOfLifeAlert": false,
          //             "endOfSaleAlert": true,
          //             "endOfLifeManual": true,
          //             "endOfSaleManual": true,
          //             "syncDate": "2022-07-06T07:15:39.427",
          //             "ByUser": false,
          //             "imageUrl": "https://www.mouser.com/images/kemet/images/SMD_MLCC_new_t.jpg",
          //             "OverallRisk": "53%",
          //             "EstimatedYearsToEOL": "9.7",
          //             "LifecycleRisk": "Medium",
          //             "SEoutofdate": false,
          //             "Priority": 1,
          //             "isPreferred": false,
          //             "isNRND": false,
          //             "isForbidden": false,
          //             "isSE": false
          //           },
          //           {
          //             "DistributorPartId": "0f384555-fcb2-490e-80c3-9caecb3b657f",
          //             "ManufacturerName": "KYOCERA AVX",
          //             "ManufacturerPartNumber": "06033D105KAT2A",
          //             "Description": "KYOCERA AVX - 06033D105KAT2A - Keramikvielschichtkondensator, SMD, 1 µF, 25 V, 0603 [Metrisch: 1608], ± 10%, X5R, AVX 0603 MLCC",
          //             "Datasheet": "",
          //             "LoginAssign": "Authorised Support lvl I",
          //             "DateAssign": "2022-07-06T07:17:04.143",
          //             "LoginUnassign": null,
          //             "DateUnassign": null,
          //             "isSelected": true,
          //             "endOfLifeAlert": true,
          //             "endOfSaleAlert": false,
          //             "endOfLifeManual": false,
          //             "endOfSaleManual": false,
          //             "syncDate": "2022-07-06T07:15:58.58",
          //             "ByUser": false,
          //             "imageUrl": "https://de.farnell.com/productimages/standard/en_GB/1458900-40.jpg",
          //             "OverallRisk": "13.8%",
          //             "EstimatedYearsToEOL": "19.7",
          //             "LifecycleRisk": "Low",
          //             "SEoutofdate": false,
          //             "Priority": 3,
          //             "isPreferred": false,
          //             "isNRND": false,
          //             "isForbidden": false,
          //             "isSE": false
          //           }
          //         ]
          //       }
          //     ]
          //   }
          // }


            let newJson = {
              draw: json.data.draw,
              recordsFiltered: json.data.recordsFiltered,
              recordsTotal: json.data.recordsTotal,
              data: []
            }
            let rows = [];
          vue.lengthMenu = json.data.data.length;

            for (let i = 0, lei = json.data.data.length; i < lei; i++ ) {

              let row = {};

              let objBomPartId = {
                bomPartId: json.data.data[i].bomPartId,
                value: {
                  display: json.data.data[i].bomPartId,
                  filter: json.data.data[i].bomPartId,
                  sort: json.data.data[i].bomPartId
                }
              };
              let bomPartId = "col___bomPartId";
              row[bomPartId] = objBomPartId;

              let objBomParts = {
                bomParts: null,
                value: {
                  display: "",
                  filter: "",
                  sort: ""
                }
              };
              let bomParts = "col___BomParts";
              row[bomParts] = objBomParts;

              let objQuantity = {
                quantity: null,
                value: {
                  display: "",
                  filter: "",
                  sort: ""
                }
              };
              let quantity = "col___quantity";
              row[quantity] = objQuantity;

              let objPartNumber = {
                partNumber: json.data.data[i].PartNumber,
                value: {
                  display: json.data.data[i].PartNumber,
                  filter: json.data.data[i].PartNumber,
                  sort: json.data.data[i].PartNumber
                }
              };
              let partNumber = "col___partNumber";
              row[partNumber] = objPartNumber;

              let objPartReference = {
                partReference: json.data.data[i].PartReference,
                value: {
                  display: json.data.data[i].PartReference,
                  filter: json.data.data[i].PartReference,
                  sort: json.data.data[i].PartReference
                }
              };
              let partReference = "col___partReference";
              row[partReference] = objPartReference;

              let objRemarks = {
                remarks: json.data.data[i].Remarks,
                value: {
                  display: json.data.data[i].Remarks,
                  filter: json.data.data[i].Remarks,
                  sort: json.data.data[i].Remarks
                }
              };
              let remarks = "col___remarks";
              row[remarks] = objRemarks;

              let objRevision = {
                revision: json.data.data[i].Revision,
                value: {
                  display: json.data.data[i].Revision,
                  filter: json.data.data[i].Revision,
                  sort: json.data.data[i].Revision
                }
              };
              let revision = "col___revision";
              row[revision] = objRevision;

              let objStatus = {
                status: json.data.data[i].status,
                isManual: json.data.data[i].isManual,
                isPresent: json.data.data[i].isPresent,

                value: {
                  display: json.data.data[i].status,
                  filter: json.data.data[i].status,
                  sort: json.data.data[i].status
                }
              };
              let status = "col___status";
              row[status] = objStatus;

              let objAssembly = {
                assembly: json.data.data[i].assembly,

                value: {
                  display: json.data.data[i].assembly,
                  filter: json.data.data[i].assembly,
                  sort: json.data.data[i].assembly
                }
              };
              let assembly = "col___assembly";
              row[assembly] = objAssembly;

              let objPartId = {
                partId: json.data.data[i].partId,

                value: {
                  display: json.data.data[i].partId,
                  filter: json.data.data[i].partId,
                  sort: json.data.data[i].partId
                }
              };
              let partId = "col___partId";
              row[partId] = objPartId;

              let objRevisionId = {
                revisionId: json.data.data[i].revisionId,

                value: {
                  display: json.data.data[i].revisionId,
                  filter: json.data.data[i].revisionId,
                  sort: json.data.data[i].revisionId
                }
              };
              let revisionId = "col___revisionId";
              row[revisionId] = objRevisionId;

              if (json.data.data[i].alternatives.length > 0) {

                let trigEol = false;
                let trigEos = false;
                let trigEolManual = false;
                let trigEosManual = false;
                for (let j = 0, lej = json.data.data[i].alternatives.length; j < lej; j++) {
                  if (json.data.data[i].alternatives[j].endOfLifeAlert == true) {
                    trigEol = true;
                  }
                  if (json.data.data[i].alternatives[j].endOfLifeManual == true) {
                    trigEolManual = true;
                  }
                  if (json.data.data[i].alternatives[j].endOfSaleAlert == true) {
                    trigEos = true;
                  }
                  if (json.data.data[i].alternatives[j].endOfSaleManual == true) {
                    trigEosManual = true;
                  }


                }
                if (trigEol == true) {
                  json.data.data[i].endOfLifeAlert = true;
                } else {
                  json.data.data[i].endOfLifeAlert = false;
                }
                if (trigEos == true) {
                  json.data.data[i].endOfSaleAlert = true;
                } else {
                  json.data.data[i].endOfSaleAlert = false;
                }
                if (trigEolManual == true) {
                  json.data.data[i].endOfLifeManual = true;
                } else {
                  json.data.data[i].endOfLifeManual = false;
                }
                if (trigEosManual == true) {
                  json.data.data[i].endOfSaleManual = true;
                } else {
                  json.data.data[i].endOfSaleManual = false;
                }

              }

              let objEolAlert = {
                endOfLifeAlert: json.data.data[i].endOfLifeAlert,
                endOfSaleAlert: json.data.data[i].endOfSaleAlert,
                endOfLifeManual: json.data.data[i].endOfLifeManual,
                endOfSaleManual: json.data.data[i].endOfSaleManual,
                value: {
                  display: json.data.data[i].endOfLifeAlert,
                  filter: json.data.data[i].endOfLifeAlert,
                  sort: json.data.data[i].endOfLifeAlert
                }
              };
              let eolAlert = "col___eolAlert";
              row[eolAlert] = objEolAlert;

              let objMpns = {
                mpns: json.data.data[i].alternatives,

                value: {
                  display: json.data.data[i].alternatives,
                  filter: json.data.data[i].alternatives,
                  sort: json.data.data[i].alternatives
                }
              };
              let mpns = "col___mpns";
              row[mpns] = objMpns;


              for (let j = 0, lej = json.data.data[i].partProperties.length; j < lej; j++ ) {

                let obj = {
                  propertyId: json.data.data[i].partProperties[j].propertyId,
                  name: json.data.data[i].partProperties[j].name,
                  value: {
                    display: json.data.data[i].partProperties[j].value,
                    filter: json.data.data[i].partProperties[j].value,
                    sort: json.data.data[i].partProperties[j].value
                  },


                }

                let key = "col___"+json.data.data[i].partProperties[j].propertyId;
                row[key] = obj;


              }



              rows.push(row);
            }


            newJson.data = rows;

            //console.log(newJson)

            return JSON.stringify(newJson);
          },

        }



          if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
              this.mainTable.destroy();

          }

          this.mainTable = $('#place'+this._uid).DataTable(option);

      this.mainTable.column(0).visible(false);

          let _mainTable = this.mainTable;

          let el = document.getElementsByClassName("dataTables_processing")[0]

          if(this.isPlugin){
            el.classList.add("processing-top-plugin");
          }else{
            el.classList.add("processing-top");
          }


      //search input change view
      let searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }

      let searchplaceGlobal = document.getElementById("place"+this._uid+"_filter")

      let advencedSearch = document.createElement("div");
      advencedSearch.setAttribute("class", "advencedSearch");
      advencedSearch.setAttribute("id", "advencedSearch");

      let row1 = document.createElement("div");
      advencedSearch.appendChild(row1);
      let row2 = document.createElement("div");
      advencedSearch.appendChild(row2);
      let row3 = document.createElement("div");
      advencedSearch.appendChild(row3);

      let debounceTimeout = null;

      function filterColumn(table,ev) {
        //console.log('filterColumn');
        //console.log(ev);
        clearTimeout(debounceTimeout);
        for (let i = 0, lei = vue.columns.length; i < lei; i++){
          if (table.column(i).search() != "") {

            table.column(i).search("")
          }
          //table.column(i).search("").draw();
        }
        let filter0 = document.querySelector('#col0_filter');
        let select0 = document.querySelector('#col0_select');

        let filter1 = document.querySelector('#col1_filter');
        let select1 = document.querySelector('#col1_select');

        let filter2 = document.querySelector('#col2_filter');
        let select2 = document.querySelector('#col2_select');
        let actualFilterChange = false;
        let relatedPairs = [
          [select0,filter0],
          [select1,filter1],
          [select2,filter2]
        ];
        relatedPairs.forEach(pair => {

          if(ev.target === pair[0]){

            if(pair[0].value == ""){
              if(pair[1].value !== ""){
                pair[1].value = "";
                actualFilterChange = true;

              }
            } else {
              if(pair[1].value !== ""){
                actualFilterChange = true;
                table.column(pair[0].value).search(pair[1].value)
              }

            }
          } else if(ev.target === pair[1]){

            if(pair[0].value !== ""){
              if(pair[1].value !== pair[1].myLastVal){
                pair[1].myLastVal = pair[1].value;
                actualFilterChange = true;
                table.column(pair[0].value).search(pair[1].value)
              }
            }

          } else if (pair[0].value !== "" && pair[1].value !== "") {
            table.column(pair[0].value).search(pair[1].value)
          }
        });
        if(actualFilterChange){
          debounceTimeout = setTimeout(table.draw,250);
        }
      }

      //console.log('adding search events');
      document.querySelectorAll(['input.column_filter', 'select.column_filter']).forEach((el) => {
        if(!el.myEventAdded){
          //console.log('adding event');

          el.addEventListener(el.type === 'text' ? 'keyup' : 'change', (ev) =>

            filterColumn(vue.mainTable,ev)
          );
          el.myEventAdded = true;
        }
      });


      $('#place'+vue._uid + ' thead').on('click', 'th', function(event) {
        vue.clickedColumnIndex = $(this).index();

        let tableLeft = $('#place'+vue._uid).offset().left;
        vue.mouseXInTable = event.pageX - tableLeft;


      });

      vue.mainTable.on('draw', function () {
        //console.log('om draw');
        if (vue.clickedColumnIndex !== null) {

          let th = $('#place' + vue._uid + ' thead th').eq(vue.clickedColumnIndex);
          let colLeft = th.offset().left - $('#place' + vue._uid).offset().left;

          let scrollContainer = $('#action_content_parts');
          let currentScroll = scrollContainer.scrollLeft();

          let newScroll = currentScroll + colLeft - vue.mouseXInTable;

          if (vue.colsAssign.length - 1 - vue.clickedColumnIndex < 6) {

            newScroll = 10000
            scrollContainer.scrollLeft(newScroll);

          } else {
            scrollContainer.scrollLeft(newScroll + 20);
          }

          vue.clickedColumnIndex =null;
        }
      });

      searchplaceGlobal.appendChild(advencedSearch);

          searchplace.firstChild.setAttribute("placeholder", "Enter search words")
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm" + " place" + this._uid);
          searchplace.firstChild.addEventListener("input", function(evt){

            _vue.$store.dispatch("setFilteredData", evt.target.value);

          })
          let stepWait = 0;
          let waitInterval;


          $(".dataTables_filter ." + "place" + this._uid)
          .unbind()
          .bind('input', function (e) {
            let item = $(this);
            stepWait = 0;

            if (!waitInterval) {
              waitInterval = setInterval(function () {

              if (stepWait >= 3) {
                clearInterval(waitInterval);
                waitInterval = '';
                let searchString = $(item).val();
                _mainTable.search(searchString).draw();
                stepWait = 0;
              }
              stepWait++;
            }, 150);
            }

          });

          let lengthplace = document.getElementById("place"+this._uid+"_length");

          if (lengthplace.firstChild.firstChild != null){
            lengthplace.firstChild.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
          }


          this.mainTable
          .on( 'select', function ( e, dt, type, indexes ) {

              let rowData = _mainTable.rows('.selected').data();

              console.log(rowData)
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedPartBomRow", rowData[0])




          })
          .on('deselect', function (e, dt, type, indexes) {

            _vue.$store.dispatch("unselectAlternative");
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");

          });

          $('#place'+this._uid+' tbody').on('dblclick', 'tr', function (e) {
            let rowData = _mainTable.rows( this._DT_RowIndex ).data();

            _vue.goTo(rowData[0]);

          } );



    },
    goTo(goalObj){

      console.log(goalObj)
      if (goalObj.col___revisionId.revisionId == 0){

        let obj = {
          text: this.lang.alert_OutOfSync,
          time: 15,
          type: "warning"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return
      }
      let from = "/ProjectManager/ProjectBom";

      let to = "/PartManager/PartDetails";
      let elementRevisionId = goalObj.col___revisionId.revisionId;
      let id = goalObj.col___partId.partId;

      let obj = {
        col___revisionId: {
          revisionId: goalObj.col___revisionId.revisionId,
          partId: goalObj.col___partId.partId
        },
        col___revision: {
          revisionId: goalObj.col___revisionId.revisionId

        },
        col___status: {
          assembly: goalObj.col___assembly.assembly

        }
      }

console.warn(obj)


      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedBomRow");

      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      let sourceType = "main";
      if (this.$route.path == "/LibraryManager/LibraryDetails") {
        sourceType = "details";
      }
      if (this.$route.path == "/PartManager/PartDetails") {
        sourceType = "details";
      }
      if (this.$route.path == "/ProjectManager/ProjectBom") {
        sourceType = "details";
      }


      let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: elementRevisionId,
        id: id,
        sourceType: sourceType, //"details"
        sourceId: this.projectId,
        sourceRevisionId: this.revisionId,
        end: false,
        selectedBomRow: this.$store.getters.selectedBomRow[0],
        bomId: this.$route.query.bomId
      }

      this.$store.commit("FORWARDROUTINGDATA", routingObject)


      this.$router.push({ path: to, query: routingObject });
    },
    buildContextMenu(){


      let _vue = this;


      //context-menu
      let tableid = $("#place" + this._uid);

      $("#place" + this._uid + " tbody tr")
      .on("contextmenu", function(e) {

        let tr = $(this).closest('tr');
        let row = _vue.mainTable.row( tr );

        let data = row.data();

        _vue.contextMenu.row = data



        _vue.contextMenu.funcAction = function(_vue, action){

          //calling component methods depending on the context menu item clicked

          if (action == "Place"){
            _vue.$store.dispatch("deleteAllSelectedRows");
            _vue.$store.dispatch("setSelectedRows", [data]);
            function place() {
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.placePart();
            }
            setTimeout(place, 2000);
          }
          if (action == "Details"){
            _vue.$store.dispatch("deleteAllSelectedRows");
            _vue.$store.dispatch("setSelectedRows", [data]);
            _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.details();
          }
          if (action == "Derive"){
            _vue.$store.dispatch("deleteAllSelectedRows");
            _vue.$store.dispatch("setSelectedRows", [data]);
            _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.derive();
          }
          if (action == "Withdraw"){
            _vue.$store.dispatch("deleteAllSelectedRows");
            _vue.$store.dispatch("setSelectedRows", [data]);
            _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.withdraw();
          }

          if (action == "Delete" && _vue.$store.getters.currentUser.role == "Admin"){
            _vue.$store.dispatch("deleteAllSelectedRows");
            _vue.$store.dispatch("setSelectedRows", [data]);
            //_vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent._delete();
          }

          return true;
        }

        let height = tableid.height();

        let offsetX = tableid.offset().left;
        let offsetY = tableid.offset().top;

        let top = e.clientY - offsetY + 170;
        let left = e.clientX - offsetX + 10;


        $("#context-menu-"+_vue.name).css({
          display: "block",
          top: top,
          left: left
        });
        return false; //blocks default Webbrowser right click menu
      })
      .on("click", function() {

        $("context-menu-"+_vue.name).hide();
      });

      $("#context-menu-"+_vue.name + " a").on("click", function() {

        $(this)
          .parent()
          .hide();
      });
      document.addEventListener('click', function(e){
        let clickInside = e.target.closest("#context-menu-"+_vue.name);

        if(clickInside == null){

          let contextMenu = document.getElementById("context-menu-"+_vue.name);
          if (contextMenu != null){
            contextMenu.setAttribute('style', 'display:none');
          }

        }
      });
      //context-menu
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .BomPartsMPNApiFilteredComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      //white-space:nowrap;
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 50px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }
    .processing-top{
      top: 50px;
    }


    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .dataTables_length{
      margin-left: 20px;
      width: 200px;
      float: left;
    }
    .dataTables_length label{
      display: inline-flex;
    }
    .select-length{
      padding: 0.1rem;
      margin-left:10px;
      margin-right:10px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      //margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
      width: 450px;
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image-category{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;

    }
    .badge{
      margin-right: 1px;

      margin-bottom: 2px;
    }
    .badges{
      margin-top: 3px;
      margin-bottom: 2px;
    }
    .image-svg{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-right: 3px;
      margin-bottom: 3px;
      background-color: white;
      padding: 2px;
    }
    .search-input-header{
      margin-top: 5px;
    }
    .advanced-search-panel{
      display: block;
      margin-bottom: 15px;
      border: solid 1px #999;
      padding: 10px;
       border-radius: 5px;
    }
    .advanced-search tr{

      height: 28px;

    }

    .nodisplay{
      display: none;
    }
    .column-filter-input{
      width: 200px;
    }

    .badge {
      margin: 2px;
    }
    .subtable .selected{
      color: #333;
    }
    .se-risk{
      width: 110px;
    }
    .se-eol{
      width: 110px;
    }
    .inline-block {
      display: inline-block;
      margin-right: 5px;
    }
    .mpn-row{
      border-bottom: 1px solid;
    }
    .no-wrap{
      white-space: nowrap;
    }
    .nowrapForPartNumber{
      white-space: nowrap;
    }
    .part-reference{
      width: 200px;
      //white-space: nowrap;
      display:block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/BomPartsMPNApiFilteredComponent.vue